import Layout from "./layout";
import { Button, Box } from "@mui/material";
import { useNavigate } from 'react-router-dom';// Page linking using this 

const EventandStaff  = () => {
    const navigate = useNavigate();// Page linking using this 


    return(
        <>  
        <Layout/>
        <h1 className="title">Issue Product</h1>
        <Box
                sx={{display: 'flex',justifyContent: 'center',alignItems: 'center',height: '50vh', gap: '8em', }}
            >
                <Button 
                    variant="contained"
                    onClick={() => {navigate('/store-Issue') }}
                    sx={{backgroundColor: '#0A64A2', color: '#fff',left:'2em', borderRadius:'0.4em' ,marginRight: '2em',padding: '37px 30px',fontSize: '14px',fontWeight: 'bold',fontFamily: ' sans-serif',
                         }}
                >
                    Issue Products For Staff 
                </Button>
                    
                <Button
                    variant="contained" onClick={() => {navigate('/issue-CreateEv') }} // Page linking using this 
                    sx={{backgroundColor: '#0A64A2',color: '#fff',padding: '37px 30px',fontSize: '14px',borderRadius:'0.4em' ,fontWeight: 'bold',fontFamily: ' sans-serif',
                    }}
                >
                  Issue Products For Event
                </Button>
            </Box>
     
        </>
    )     
}

export default EventandStaff;   

